import React from 'react';
import { Router } from '@abyss/web/ui/Router';
import { CommonFooter } from '@/common/Layouts/Footer';
import { CommonHeader } from '@/common/Layouts/CommonHeader';
import { AppLayoutBody } from './AppLayout.styles';

export const AppLayout = () => {
  return (
    <React.Fragment>
      <CommonHeader />

      {/* main */}
      <AppLayoutBody>
        <Router.Outlet />
      </AppLayoutBody>

      {/* footer */}
      <CommonFooter />
    </React.Fragment>
  );
};
